import * as angular from 'angular';
import {IController} from "angular";

export class AgentsGroupsNavBarCtrl implements IController {

  ids: any;

  onChange: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {

  }

  $onChanges(changes) {

  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentsGroupsNavBar', {
    bindings: {
      agentsGroup: '<',
      isDisabled: '<',
      enableTotals: '<?',
      onDuty: '<?',
      offDuty: '<?',
      total: '<?',
      onChange: '&'
    },
    template: require('./agents-groups-nav-bar.html').default,
    controller: AgentsGroupsNavBarCtrl
  });
